import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'
import StepLayout from './StepLayout'
import { Icon } from '@iconify/react'

const Locations = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: (
          <span>
            {t('Open your devices Settings app')}
            &nbsp;
            <Icon style={{ display: 'initial' }} fontSize='1.5rem' icon='material-symbols:settings-outline' />
            &nbsp;
            {t('and tap Location')}.
          </span>
        ),
        img: [
          {
            src: '/images/login/backup13.jpg'
          }
        ]
      },
      {
        title: <span>{t('Turn on Location')}.</span>,
        img: [
          {
            src: '/images/login/backup14.jpg'
          }
        ]
      },
      {
        title: <span>{t('Open your devices Settings app and tap Security and privacy')}.</span>,
        img: [
          {
            src: '/images/login/backup15.jpg'
          }
        ]
      },
      {
        title: <span>{t('Tap Find My Device')}.</span>,
        img: [
          {
            src: '/images/login/backup16.jpg'
          }
        ]
      },
      {
        title: <span>{t('Check if Find My Device is turned on')}.</span>,
        img: [
          {
            src: '/images/login/backup17.jpg'
          }
        ]
      }
    ],
    [t]
  )

  return <StepLayout title={t('Back up Locations')} step={step} />
}

export default Locations
